export class OrderLoyaltyConditionsChangedError extends Error {
    constructor() {
        super('ERROR_ORDER_LOYALTY_CONDITIONS_CHANGED');
    }
}
